import React, { useEffect } from "react";
import "./question.css";
import HintButton from "./HintButton";
import { useState } from "react";

const Question = ({
  item,
  setData,
  index,
  setElapsedTime,
  myArray,
  setMyArray,
  data
}) => {
  const [isCorrect, setIsCorrect] = useState(false);
  function checkans() {

    const newData = myArray?.map((item, index) => {
      if (item.answer == item.solution) {

        //  isCorrect(true);
        return {
          ...item,
          isCorrect: true,
        };
      } else if (item.answer != item.solution) {
        return {
          ...item,
          isCorrect: false,
        };
      }
      return {
        ...item,
      };
    });
    setMyArray(newData);
  }
  useEffect(() => {
    checkans()
  }, [data?.answer])

  return (
    <>
      <div className="questionsMain">
        <p className="questions">{item.question}</p>
        <div className="btnpara">
          {/* <button>Hint</button> */}

          <HintButton setElapsedTime={setElapsedTime} hint={item.hint} />

          <input
            onChange={(text) => {
              setData(text.target.value, index);
              checkans();
            }}
            type="text"
            className="inputUnderline"
            placeholder="תשובה"
            style={item?.isCorrect ? { borderBottom: "3px solid rgb(53 185 53)" } : { borderBottom: "1px solid #000000" }}
          />
        </div>
        <div>
          {/* {item?.isCorrect && "Correct"} */}
          {/* {
              item?.isCorrect === false && "Incorrect"
            } */}
        </div>
      </div>
    </>
  );
};

export default Question;
